GP.GPMod('MessagePane.Inbox', function(self) {
    var vent  = null;
    var _util = null;
    var _horse_shit = true;

    var data = {
        init: function() {
            vent   = self.vent;
            _util = self.app.Util;
            data.unread_thread_ids = _.toArray(GP.sdata.my_user.unread_thread_ids);
        },
        initial_fetch: false,
        fetching_page: false,
        first_page_reached: false,
        inbox_filter: 'all',
        unread_only: 0,
        min_msg_id: 0,
        max_msg_id: 0,
        prev_min_msg_id: 0,
        prev_min_msg_ids: [],
        activity_tags: ['WINK','QUICKCHAT','FAVORITED','RATED','MEETME'],
        valid_filters: ['all', 'friends', 'favorites', 'friends_favs', 'distance', 'free', 'activities'],
        preview_max_len: 25,
        unread_thread_ids: [],
        pane_content_top: 123,
        button_height: 34,
        original_page_title: document.title,
        notify_page_title: '',
        page_title_interval: false,
        load_thread_external_cb: null,
        selected_thread_id: 0,
        reset: function() {
            gui.$next_page.removeClass('disabled');
            gui.$page_one.removeClass('disabled');
            gui.$prev_page.removeClass('disabled');
            gui.$page_count.text(1);
            this.first_page_reached = false;
            this.min_msg_id = 0;
            this.max_msg_id = 0;
            this.prev_min_msg_id = 0;
            this.prev_min_msg_ids = [];
            GP.sdata.MessagingThreads.reset_metadata();
        }
    };

    var gui = {
        init: function() {
            this.$footer = self.$el.find('.pane-footer');
            this.$filters = self.$el.find('.btn-inbox-filter');
            this.$btn_select = self.$el.find('.btn-select');
            this.$select_options_wrap = self.$el.find('.select-options-wrap');
            this.$filter_wrap = self.$el.find('.filter-wrap');
            this.$msg_age_filter = self.$el.find('#msg-age-filter');
            this.$msg_age_start = self.$el.find('#msg-age-start');
            this.$msg_age_end = self.$el.find('#msg-age-end');
            this.$msg_verified_filter = self.$el.find('#msg-verified-filter');
            this.$msg_auto_hide = self.$el.find('#msg-auto-hide');
            this.$msg_premium_hide = self.$el.find('#msg-premium-hide');
            this.$all_unread = self.$el.find('#switch-unread');
            this.$message_buttons = self.$el.find('#message-buttons');
            this.$cancel_options = self.$el.find('#btn-cancel-options');
            this.$btn_mark_read = self.$el.find('#btn-mark-read');
            this.$del_threads = self.$el.find('#delete-threads');
            this.$inbox_updates = self.$el.find('#inbox-updates');
            this.$pane_content = self.$el.find('.pane-content');
            this.$page_count = self.$el.find('.pane-footer .page-count .count');
            this.$page_one  = self.$el.find('.pane-footer .first');
            this.$prev_page = self.$el.find('.pane-footer .prev');
            this.$next_page = self.$el.find('.pane-footer .next');
            this.$msg_pref_wrap = self.$el.find('.pane-header .message-settings');
            this.$msg_pref_toggle = self.$el.find('.pane-header #btn-message-settings');
            this.$msg_pref_inputs = self.$el.find('#msg-prefs-form :input');
            this.$msg_pref_save = self.$el.find('.pane-header #msg-prefs-save');
            this.$msg_pref_cancel = self.$el.find('.pane-header #msg-prefs-cancel');
            this.$filters_indicator = self.$el.find('.pane-header .filters-indicator');
            this.$unread_count_tab = $('#message-pane-tab .counter');
            this.$unread_count_nav = $('#navbar-controls .nav-messages-count');
            this.$unread_count_nav_mobile = $('#mobile-sidebar .nav-messages-count-mobile');

            if ($('#threads-region').length) {
                // initilize regions
                var rm = new Marionette.RegionManager();
                this.regions = rm.addRegions({
                    threads: '#threads-region'
                });

                var threads_list = new self.app.views.ThreadsList({
                    users: GP.sdata.MessagingUsers,
                    collection: GP.sdata.MessagingThreads
                });
                this.regions.threads.show(threads_list);
            }

            // handler to close the prefs popover on any click outside of it
            $(document).on('click.message_prefs', function(e) {
                if (!$(e.target).closest('.message-settings').length) {
                    events.cancel_msg_prefs();
                }
            });

            events.toggle_prefs_filter_indicator();
            events.toggle_thread_style();
        },
        set_content_height: function() {
            // adjust the content height (mobile view only)
            var additional_height = $(window).height() - (gui.$footer.offset().top + gui.$footer.outerHeight());
            gui.$pane_content.css('min-height', (gui.$pane_content.height() + additional_height));
        }
    };

    var apis = {
        get_inbox: function(bust_cache) {
            data.initial_fetch = true;
            if (data.fetching_page) {
                return;
            }

            // remove threads which aren't currently open
            var open_threads = GP.reqres.request('MessagePane.Thread:get_open_threads');
            GP.sdata.MessagingThreads.filter_by_id(open_threads);

            var get_inbox_input = {
                filter: data.inbox_filter,
                unread_only: data.unread_only,
                last_msg_id: data.min_msg_id
            };

            // pass flag to get_inbox module to bust msg inbox cache if bust_cache true param was passed in
            if (typeof bust_cache != 'undefined' && bust_cache === true) {
                get_inbox_input.bust_cache = true;
            }

            GP.sdata.MessagingThreads.fetch({
                remove: false,
                data: $.param(get_inbox_input),
                beforeSend: function() {
                    data.fetching_page = true;
                    data.prev_min_msg_id = data.min_msg_id;
                    GP.sdata.MessagingThreads.reset_metadata();
                    self.$el.find('.spinner-container').spin('gp_small');
                    self.$el.find('.loading').show();
                }
            }).done(function(inbox_data) {
                data.min_msg_id = GP.sdata.MessagingThreads.min_msg_id;
                data.max_msg_id = GP.sdata.MessagingThreads.max_msg_id;
                data.fetching_page = false;

                // call the callback setup from load_thread_external, if we have one
                if (typeof(data.load_thread_external_cb) === "function") {
                    var cb_function = data.load_thread_external_cb;
                    data.load_thread_external_cb = null;
                    cb_function();
                }
            }).always(function(inbox_data) {
                // msg.get_inbox will return the show_expire property if we need to add the yellow expire thread
                if (inbox_data.show_expire) {
                    var thread_model = {
                        msg_id: 1,
                        msg_class: 'expire',
                        tag: [],
                    };
                    GP.sdata.MessagingThreads.add(thread_model, {merge: true});
                }

                self.$el.find('.loading').hide();
                self.$el.find('.spinner-container').spin(false);
                vent.trigger('Nanoscroller:message-pane:setup');
            });
        },
        del_threads: function(threads_in) {
            var threads_ar = (_.isArray(threads_in)) ? threads_in : self.$el.find('input.delete-thread').serializeArray();
            $.post(_util.clean_url('members/msg/del_thread'), threads_ar);
            _.each(threads_ar, function(thread_obj) {
                vent.trigger('ThreadLayout.thread-'+thread_obj.value+':close');
                events.decrement_unread(thread_obj.value);
                GP.sdata.MessagingThreads.remove(thread_obj.value);
            });
            events.hide_del_thread();
            // TODO: delete user object associated with thread
        },
        mark_viewed: function(thread_id, other_duid) {
            self.api.post('/app/members/msg/read', {
                data: {
                    "otherUserId": other_duid,
                    "threadId": thread_id,
                },
                // no_parse_url: true,
            })
            .done(function(json) {

            });
        },
        mark_viewed_multiple: function(threads) {
            $.post('/members/msg/mark_read', {
                threads: threads
            }).done(function(json) {

            });
        }
    };

    var events = {
        init: function() {
            gui.$filters.on('click', function(e) { events.change_filter(null, e); });
            gui.$btn_select.on('click', this.select_options);
            gui.$all_unread.on('change', this.change_all_unread);
            gui.$del_threads.on('click', apis.del_threads);
            gui.$cancel_options.on('click', this.hide_select_options);
            gui.$btn_mark_read.on('click', this.mark_read);
            gui.$page_one.on('click', this.page_one);
            gui.$prev_page.on('click', this.prev_page);
            gui.$next_page.on('click', this.next_page);
            gui.$msg_pref_toggle.on('click', this.toggle_msg_prefs);
            gui.$msg_pref_save.on('click', this.save_msg_prefs);
            gui.$msg_pref_cancel.on('click', this.cancel_msg_prefs);
            gui.$msg_verified_filter.on('change', this.check_verified);
            gui.$msg_age_filter.on('change', this.check_ages_checkbox);
            gui.$inbox_updates.on('click', function() { events.change_filter('all'); });
            vent.on('MessagePane.'+self.moduleName+':show', this.show);
            vent.on('MessagePane.'+self.moduleName+':add_selected', this.add_selected);
            vent.on('MessagePane.'+self.moduleName+':remove_selected', this.remove_selected);
            vent.on('MessagePane.'+self.moduleName+':load_thread_for_user', this.load_thread_for_user);
            vent.on('MessagePane.'+self.moduleName+':load_thread_external', this.load_thread_external);
            vent.on('MessagePane.'+self.moduleName+':load_thread_from_push', this.load_thread_from_push);
            vent.on('MessagePane.'+self.moduleName+':show_del_thread', this.show_del_thread);
            vent.on('MessagePane.'+self.moduleName+':hide_del_thread', this.hide_del_thread);
            vent.on('MessagePane.'+self.moduleName+':decrement_unread', this.decrement_unread);
            vent.on('MessagePane.'+self.moduleName+':del_threads', apis.del_threads);
            vent.on('MessagePane.'+self.moduleName+':set_first_page_reached', this.set_first_page_reached);
            vent.on('MessagePane.'+self.moduleName+':reset', this.reset);
            vent.on('MessagePane.'+self.moduleName+':set_messages_read', this.set_messages_read);
            vent.on('MessagePane.'+self.moduleName+':change_filter', this.change_filter);

            // free users see the message pane as default
            if (GP.sdata.my_user.membership == 'FREE') {
                apis.get_inbox();
            }

            // free men: auto-pop existing threads & check for request pic messages
            if (GP.sdata.my_user.membership == 'FREE' && GP.sdata.my_user.gender == 'MAN' && _bank_site !== true) {
                $.cookie.json = true;
                var date = new Date();
                var ft_cookie = $.cookie('free_threads');
                if (typeof(ft_cookie) == 'undefined' || ft_cookie.date != date.yyyymmdd()) {
                    _util.set_cookie('free_threads', { threads: [], date: date.yyyymmdd() }, 1);
                }
                events.auto_show_threads(true);

                if (GP.sdata.my_user.seeking.indexOf('WOMAN') !== -1) {
                    setTimeout(events.request_pic_message, 30000);
                }
            }

        },
        reset: function() {
            // this is only used for membership changes: free to silver / silver to free
            events.change_filter('all');
            events.toggle_thread_style();
        },
        is_shown: function() {
            return ($('body').hasClass('right-drawer-shown') && $('body').hasClass('message-pane-shown')) ? true : false;
        },
        show: function() {
            if (GP.sdata.MessagingThreads.length === 0 || !data.initial_fetch) {
                events.page_one();
            }
            events.reset_page_title();

            // hide any new-message growls
            $('#jGrowl').find('.new-message').closest('.jGrowl-notification').remove();

            // if (MoshPit.get_size() == 'mobile') {
            //     gui.set_content_height();
            // }
        },
        add_selected: function(thread_id) {
            events.remove_selected();
            data.selected_thread_id = thread_id;

            var thread_model = GP.sdata.MessagingThreads.get(thread_id);

            if (typeof thread_model != 'undefined') {
                thread_model.set('selected', true);

                var membership = GP.sdata.my_user.membership,
                    other_user = thread_model.get('other_user'),
                    gold_initiated = thread_model.get('gold_initiated');

                if ( membership != 'FREE' || (membership == 'FREE' && (other_user == 69 || gold_initiated)) ) {
                    events.decrement_unread(thread_id);
                }
            }
        },
        remove_selected: function() {
            if (data.selected_thread_id) {
                var thread_model = GP.sdata.MessagingThreads.get(data.selected_thread_id);
                if (thread_model) {
                    thread_model.set('selected', false);
                }
            }
            data.selected_thread_id = 0;
        },
        change_filter: function(filter, evt) {
            if (evt && evt.currentTarget) {
                filter = $(evt.currentTarget).data('filter');
                gui.$filters.removeClass('active');
                $(evt.currentTarget).addClass('active');
            }

            events.hide_del_thread();
            // TODO: clear out MessagingUsers
            data.reset();

            // check function input for valid inbox filter or use currently selected filter from filters dropdown
            data.inbox_filter = (typeof(filter) == 'string' && _.contains(data.valid_filters, filter)) ? filter : 'all';

            // may need to set the value of the filters dropdown if this was called from
            // a place other than the onchange event for the select element (from Page.js etc...)
            // var current_filter = gui.$filters.val();
            // if (current_filter != data.inbox_filter) {
            //     gui.$filters.val(data.inbox_filter);
            // }

            apis.get_inbox();
            data.prev_min_msg_ids.push(data.prev_min_msg_id);

            if (data.inbox_filter == 'all') {
                // gui.$filters.val(data.inbox_filter);
                events.hide_inbox_updates();
            }
        },
        change_all_unread: function() {
            events.hide_del_thread();
            data.reset();
            var val = gui.$all_unread.filter(':checked').val();
            if (val == 'unread') {
                data.unread_only = 1;
            } else {
                data.unread_only = 0;
            }
            apis.get_inbox();
            data.prev_min_msg_ids.push(data.prev_min_msg_id);
        },
        load_thread_for_user: function(other_duid, msg_id, opened_from) {
            let that = this;

            // redirect FREE users to billing
            if (GP.sdata.my_user.membership == 'FREE') {
                vent.trigger('Page:billing_redirect');
                return;
            }

            $.get('/members/msg/get_thread_json/', {
                duid: other_duid
            })
            .done(function(thread_json) {
                if (opened_from !== undefined && opened_from !== null) {
                    thread_json.opened_from = opened_from;
                }

                const args = [thread_json];

                if (msg_id !== undefined && msg_id !== null) {
                    args.push(false, msg_id);
                }

                if (GP.sdata.my_user.membership == 'BRONZE') {
                    let callback_fn = events.load_thread_external.bind(that, ...args);

                    vent.trigger('MessagePane:handle_bronze', other_duid, thread_json, callback_fn);
                    return;
                }

                vent.trigger('MessagePane.Inbox:load_thread_external', ...args);
            });
        },
        load_thread_external: function(thread_data, from_pop_state, msg_id) {
            // console.trace('(MPI) load_thread_external() ', thread_data);
            // console.log('(MPI) load_thread_external() from_pop_state:', from_pop_state);
            // console.log('(MPI) load_thread_external() msg_id:', msg_id);

            // use this function to open the messaging pane to a specific thread from a profile or anywhere else
            // null out any callbacks that this function sets up
            data.load_thread_external_cb = null;

            var td_opened_from = thread_data.hasOwnProperty('opened_from');

            // if we're not looking at the "all" inbox or we haven't tried to grab the inbox yet
            // reset the inbox and call this function again
            if (!td_opened_from && (data.inbox_filter != 'all' || data.initial_fetch === false)) {
                gui.$filters.val('all');
                data.inbox_filter = 'all';
                data.unread_only = 0;
                data.reset();
                // TODO: clear out MessagingUsers
                // setup callback in data instead of passing into get_inbox api
                // (issue with undefined callback in done function of promise)
                data.load_thread_external_cb = events.load_thread_external.bind(null, thread_data, from_pop_state, msg_id);
                apis.get_inbox();

                return;
            }

            var user   = ((thread_data && thread_data.users && thread_data.users.length) ? thread_data.users[0] : null);
            var thread = ((thread_data && thread_data.threads && thread_data.threads.length) ? thread_data.threads[0] : null);
            if (!_.isObject(user) || !_.isObject(thread)) {
                return;
            }

            // show the message pane if its not already shown
            if (!td_opened_from && (thread_data.show_pane !== false && !events.is_shown())) {
                // console.log('(MPI) load_thread_external calling RightDrawer:show... ');
                vent.trigger('RightDrawer:show', 'MessagePane');
            }

            // add user
            GP.sdata.MessagingUsers.add(user, {merge: true});

            // add thread
            thread.loaded_external = 1;
            thread.fetch_messages = 1;
            thread.msg_id = data.max_msg_id + 1;
            GP.sdata.MessagingThreads.add(thread);

            var models = {
                user:   GP.sdata.MessagingUsers.get(user.duid),
                thread: GP.sdata.MessagingThreads.get(thread.thread_id)
            };
            var opened_from = thread_data.opened_from || '';
            // let msg_id = msg_id || null;
            vent.trigger('MessagePane.Thread:create_thread', models, from_pop_state, opened_from, msg_id);
        },
        load_thread_from_push: function(thread_data) {
            var user_obj = thread_data.users[0];
            var thread_obj = thread_data.threads[0];
            var message_obj = thread_data.messages[0];

            // Convert to string so message can be searched properly
            message_obj.msg_id = String(message_obj.msg_id);

            _util.info('load_thread_from_push called... user: %o, thread: %o, message: %o', user_obj, thread_obj, message_obj);

            // NOTE: the first version of msg2 saw very strange issues where a user would recieve their own messages, so we check that too
            // TODO: if the incoming message is from me, decrement unread (sending message from another tab) ???
            if (!_.isObject(user_obj) || !_.isObject(thread_obj) || !_.isObject(message_obj) || user_obj.duid == GP.sdata.my_user.duid) {
                return;
            }

            var open_threads = GP.reqres.request('MessagePane.Thread:get_open_threads');

            // increment unread if the thread isn't open & this is not an activity message
            if (data.selected_thread_id != thread_obj.thread_id && !events.is_activity_message(thread_obj.tag)) {
                events.increment_unread(thread_obj.thread_id, thread_obj.tag);
            }


            // if the thread isn't open, decide whether it belongs in this inbox or not
            if (open_threads.indexOf(thread_obj.thread_id) == -1) {
                if (data.inbox_filter == 'friends' && !user_obj.friend) {
                    return;
                } else if (data.inbox_filter == 'favorites' && !user_obj.favorite) {
                    return;
                } else if (data.inbox_filter == 'distance') {
                    // currently there is no way of knowing whether the user is nearby based on the information sent via cometd
                    return;
                } else if (data.inbox_filter == 'free' && user_obj.membership != 'FREE') {
                    return;
                } else if (data.inbox_filter != 'activities' && events.is_activity_message(thread_obj.tag)) {
                    // activity never show up in any inbox other than activities
                    return;
                }
            }

            // add/update the user_model
            GP.sdata.MessagingUsers.add(user_obj);

            var thread_model = GP.sdata.MessagingThreads.get(thread_obj.thread_id);

            // this thread is not in the current inbox, add it
            if (typeof(thread_model) == 'undefined') {
                // since we don't have a real total we set the fetch_messages flag
                // this is used so MessagePane.Thread will try to grab previous messages in this thread
                thread_obj.fetch_messages = 1;
                thread_obj.total = 1;
                GP.sdata.MessagingThreads.add(thread_obj);
                thread_model = GP.sdata.MessagingThreads.get(thread_obj.thread_id);
                thread_model.get('messages').add(message_obj);
            } else {
                // thread is in the current inbox, update it
                // set a few things in the thread_obj before we update the thread_model
                thread_obj.total = parseInt(thread_model.get('total'), 10) + 1;
                thread_obj.unread_total = (data.selected_thread_id == thread_obj.thread_id) ? 0 : parseInt(thread_model.get('unread_total'), 10) + 1;

                thread_obj.message = thread_obj.message.replace(/(<([^>]+)>)/gi, "");

                // logic for shortening the thread_obj.message
                // preventing to cut escaped characters in half, resulting in `that&#...`
                // simple _.unescape(string) and then _.escape(string) wouldn't work
                // cause underscore.js escapes only small set of characters (&amp;, &lt;, &gt;, &quot;, &#96;, &#x27;)
                // and `&ccedil;` for example, isn't getting unescaped to letter `ç`
                // and while escaping the entire string only `&` gets escaped, resulting in `&amp;ccedil;`
                if (thread_obj.message.length > data.preview_max_len) {
                    var max_special_chars = 8;// nr of chars of longest special character's code (e.g. '&Agrave;' which represents char 'À')
                    // check existence of & in last_8_chars
                    var last_8_chars = thread_obj.message.substring(data.preview_max_len - max_special_chars, data.preview_max_len);
                    var ampersand_position = last_8_chars.indexOf('&');
                    if (ampersand_position > -1) {
                        var end_position = data.preview_max_len - max_special_chars + ampersand_position;
                        // shorten end_position if longer than `data.preview_max_len-3`
                        end_position = Math.min(end_position, data.preview_max_len-3);
                        thread_obj.message = thread_obj.message.substring(0, end_position) + '...';
                    } else {
                        thread_obj.message = thread_obj.message.substring(0, data.preview_max_len-3) + '...';
                    }
                }

                thread_model.set(thread_obj);

                // update the thread_models messages collection
                thread_model.get('messages').add(message_obj);
                // if the thread is open do a few misc things
                if (open_threads.indexOf(thread_obj.thread_id) != -1) {
                    vent.trigger('MessagePane.Thread:set_max_msg_id', {'thread_id' : thread_obj.thread_id, 'msg_id' : message_obj.msg_id });
                    // open but not selected, increment/show unread messages count
                    if (data.selected_thread_id != thread_obj.thread_id) {
                        vent.trigger('ThreadMiniProfile.'+thread_obj.thread_id+':increment_unread_count');
                    }

                    if (message_obj.direction == "recipient" && GP.sdata.my_user.gender == 'MAN') {
                        vent.trigger('ThreadLayout.thread-'+thread_obj.thread_id+':hide_priority_helpers');
                    }

                    // hit backend to mark viewed since thread is open and sent notification to sending user
                    apis.mark_viewed(thread_obj.thread_id, thread_model.get('other_duid'));
                }

                // remove priority upgrade thread item when. Needed when not viewing the
                // thread and a new message arrives through push.
                if (message_obj.direction == "recipient" && GP.sdata.my_user.gender == 'MAN') {
                    thread_model.get('messages').remove(thread_model.get('messages').where({msg_id: 3}));
                }
            }

            // set allow_private_vc flag if a message came in through push
            thread_model.get('messages').allow_private_vc = true;

            events.set_messages_read(thread_obj.thread_id);

            // update our internal msg_id
            data.max_msg_id = message_obj.msg_id;
        },
        is_activity_message: function(tag_array) {
             return _.intersection(data.activity_tags, tag_array).length > 0;
        },
        select_options: function() {
            let select_option = $(this).data('select');

            if (select_option === 'messages') {
                vent.trigger('ThreadList:show_checkboxes');
            } else if (select_option === 'unread') {
                vent.trigger('ThreadList:show_checkboxes_unread');
            } else if (select_option === 'read') {
                vent.trigger('ThreadList:show_checkboxes_read');
            } else if (select_option === 'all') {
                vent.trigger('ThreadList:show_checkboxes_all');
            }

            // Show checkbox cancel / delete button options
            gui.$select_options_wrap.removeClass('hide');
            gui.$filter_wrap.addClass('hide');
        },
        hide_select_options: function() {
            gui.$select_options_wrap.addClass('hide');
            gui.$filter_wrap.removeClass('hide');
            vent.trigger('ThreadList:hide_checkboxes');
        },
        mark_read: function() {
            apis.mark_viewed_multiple();

        },
        show_del_thread: function() {
            // gui.$del_threads.removeClass('hide');
            var buttons_shown = gui.$message_buttons.find('button:not(.hide)').length;
            // gui.$pane_content.css('top', data.pane_content_top + (data.button_height * buttons_shown));
        },
        hide_del_thread: function() {
            // gui.$del_threads.addClass('hide');
            var buttons_shown = gui.$message_buttons.find('button:not(.hide)').length;
            // gui.$pane_content.css('top', data.pane_content_top + (data.button_height * buttons_shown));
        },
        show_inbox_updates: function(new_count) {
            gui.$inbox_updates.find('span').text(new_count);
            gui.$inbox_updates.removeClass('hide');
            var buttons_shown = gui.$message_buttons.find('button:not(.hide)').length;
            // gui.$pane_content.css('top', data.pane_content_top + (data.button_height * buttons_shown));

            gui.$filters.find('option[value="all"]').text(js_lang.inbox+' ('+new_count+')');
        },
        hide_inbox_updates: function() {
            gui.$inbox_updates.addClass('hide');
            var buttons_shown = gui.$message_buttons.find('button:not(.hide)').length;
            // gui.$pane_content.css('top', data.pane_content_top + (data.button_height * buttons_shown));

            gui.$filters.find('option[value="all"]').text(js_lang.inbox);
        },
        toggle_thread_style: function() {
            if (GP.sdata.my_user.membership == 'FREE' || MoshPit.get_size() == 'mobile') {
                $('#msg-thread-style-wrap').hide();
            } else {
                $('#msg-thread-style-wrap').show();
            }
        },
        page_one: function() {
            if (data.prev_min_msg_ids.length == 1) {
                return;
            }
            data.reset();
            apis.get_inbox();
            data.prev_min_msg_ids.push(data.prev_min_msg_id);

            gui.$page_one.addClass('disabled');
            gui.$prev_page.addClass('disabled');
            gui.$page_count.text(data.prev_min_msg_ids.length);

            data.first_page_reached = false;
            events.hide_select_options();
        },
        prev_page: function() {
            if (data.prev_min_msg_ids.length <= 1) {
                return;
            }
            // pop off the last item & grab the new last item
            data.prev_min_msg_ids.pop();
            data.min_msg_id = data.prev_min_msg_ids[data.prev_min_msg_ids.length - 1];
            apis.get_inbox();

            gui.$next_page.removeClass('disabled');
            gui.$page_count.text(data.prev_min_msg_ids.length);

            data.first_page_reached = false;
            events.hide_select_options();
        },
        next_page: function() {
            if (data.first_page_reached) {
                return;
            }
            apis.get_inbox();
            data.prev_min_msg_ids.push(data.prev_min_msg_id);

            gui.$page_one.removeClass('disabled');
            gui.$prev_page.removeClass('disabled');
            gui.$page_count.text(data.prev_min_msg_ids.length);
            events.hide_select_options();
        },
        toggle_prefs_filter_indicator: function() {
            var age_start     = 18,
                age_end       = 100,
                local_only    = 0,
                pics_only     = 0,
                verified_only = 0,
                auto_hide     = 0,
                premium_hide = 0;

            age_start = _util.check_nested(GP, 'sdata.my_user.msg_prefs.age_start')
                         ? parseInt(GP.sdata.my_user.msg_prefs.age_start, 10)
                         : age_start;
            age_end =   _util.check_nested(GP, 'sdata.my_user.msg_prefs.age_end')
                         ? parseInt(GP.sdata.my_user.msg_prefs.age_end, 10)
                         : age_end;
            local_only =_util.check_nested(GP, 'sdata.my_user.msg_prefs.local_only')
                         ? parseInt(GP.sdata.my_user.msg_prefs.local_only, 10)
                         : local_only;
            pics_only = _util.check_nested(GP, 'sdata.my_user.msg_prefs.pics_only')
                         ? parseInt(GP.sdata.my_user.msg_prefs.pics_only, 10)
                         : pics_only;
            verified_only = _util.check_nested(GP, 'sdata.my_user.msg_prefs.verified_only')
                         ? GP.sdata.my_user.msg_prefs.verified_only
                         : verified_only;
            auto_hide = _util.check_nested(GP, 'sdata.my_user.msg_prefs.auto_hide')
                         ? GP.sdata.my_user.msg_prefs.auto_hide
                         : auto_hide;
            premium_hide = _util.check_nested(GP, 'sdata.my_user.msg_prefs.premium_hide')
                         ? GP.sdata.my_user.msg_prefs.premium_hide
                         : premium_hide;

            if (age_start != 18 || age_end != 100 || local_only == 1 || pics_only == 1 || verified_only == 1 || auto_hide == 1 || premium_hide == 1) {
                gui.$filters_indicator.show();
            } else {
                gui.$filters_indicator.hide();
            }
        },
        toggle_msg_prefs: function(e) {
            if (gui.$msg_pref_wrap.hasClass('open')) {
                events.cancel_msg_prefs();
            } else {
                gui.$msg_pref_wrap.addClass('open');
            }
        },
        save_msg_prefs: function() {
            var new_prefs = {};
            _.each(GP.sdata.my_user.msg_prefs, function(pref_val, pref_name) {
                var input = $('#msg-prefs-form [name="'+pref_name+'"]');
                if (input.length) {
                    if (input.attr('type') == 'checkbox') {
                        new_prefs[pref_name] = (input.is(':checked')) ? 1 : 0;
                    } else {
                        new_prefs[pref_name] = input.val();
                    }
                }
            });

            new_prefs.verified_only = gui.$msg_verified_filter.is(':checked') ? 1 : 0;
            new_prefs.auto_hide = gui.$msg_auto_hide.is(':checked') ? 1 : 0;
            new_prefs.premium_hide = gui.$msg_premium_hide.is(':checked') ? 1 : 0;

            if (typeof(new_prefs.thread_style) != 'undefined') {
                var thread_style_int = parseInt(new_prefs.thread_style, 10);

                GP.sdata.thread_style  = thread_style_int;
                new_prefs.thread_style = thread_style_int;
            }

            GP.sdata.my_user.msg_prefs = new_prefs;

            form_data = $.param(new_prefs) + '&check_existing=1';
            $.post(_util.clean_url('members/msg/set_msg_prefs'), form_data, function(res) {
                if (res.redirect) {
                    gui.$msg_premium_hide.prop("checked", false);
                    GP.vent.trigger('Page:redirect', self.app.Util.clean_url(res.redirect));
                } else if (res.status) {
                    data.reset();
                    apis.get_inbox(true);
                }
            });
            gui.$msg_pref_wrap.removeClass('open');
            events.toggle_prefs_filter_indicator();
        },
        cancel_msg_prefs: function() {
            if (gui.$msg_pref_wrap.hasClass('open')) {
                // restore settings to what they were initially
                _.each(GP.sdata.my_user.msg_prefs, function(pref_val, pref_name) {
                    var input = $('#msg-prefs-form [name="'+pref_name+'"]');
                    if (input.length) {
                        if (input.attr('type') == 'checkbox') {
                            if (pref_val) {
                                input.attr('checked', true);
                            } else {
                                input.attr('checked', false);
                            }
                        } else {
                            input.val(pref_val);
                        }
                    }
                });
                gui.$msg_pref_wrap.removeClass('open');
            }
        },
        increment_unread: function(thread_id, tag_array) {
            if (_.contains(data.unread_thread_ids, thread_id) || events.is_activity_message(tag_array)) {
                // if we've already seen this thread or its an activity message don't increment unread
                return;
            }
            data.unread_thread_ids.push(thread_id);
            var cur_count = parseInt(gui.$unread_count_tab.text(), 10);
            var new_count = (isNaN(cur_count)) ? 1 : cur_count + 1;
            gui.$unread_count_tab.html(new_count).show();
            gui.$unread_count_nav.html(new_count).show();
            gui.$unread_count_nav_mobile.html(new_count).show();

            if (data.inbox_filter != 'all') {
                // show the "inbox updates" button if we're not in the "all inbox"
                events.show_inbox_updates(new_count);
            }

            // blink the page title if we're not in the messaging pane
            if (!events.is_shown()) {
                data.notify_page_title = '('+new_count+') '+data.original_page_title;
                clearInterval(data.page_title_interval);
                data.page_title_interval = setInterval(function() { events.swap_page_title(); }, 1500);
            }
        },
        decrement_unread: function(thread_id) {
            // all unread_threads should be in the data.unread_thread_ids array. if its not there, return.
            var unread_index = data.unread_thread_ids.indexOf(thread_id);
            if (unread_index === -1) {
                return;
            }

            // remove it from the array
            data.unread_thread_ids.splice(unread_index, 1);

            // update our counts
            var new_count = parseInt(gui.$unread_count_tab.text(), 10) - 1;
            if (!isNaN(new_count) && new_count > 0) {
                gui.$unread_count_tab.html(new_count);
                gui.$unread_count_nav.html(new_count);
                gui.$unread_count_nav_mobile.html(new_count);
            } else {
                gui.$unread_count_tab.html('').hide();
                gui.$unread_count_nav.html('').hide();
                gui.$unread_count_nav_mobile.html('').hide();
            }
        },
        swap_page_title: function() {
            if (document.title.charAt(0) == '(') {
                document.title = data.original_page_title;
            } else {
                document.title = data.notify_page_title;
            }
        },
        reset_page_title: function() {
            if (data.page_title_interval !== false) {
                clearInterval(data.page_title_interval);
                document.title = data.original_page_title;
                data.page_title_interval = false;
            }
        },
        set_first_page_reached: function() {
            data.first_page_reached = true;
            gui.$next_page.addClass('disabled');
        },
        auto_show_threads: function(first_run) {
            var minutes_since_join  = Math.abs(new Date() - new Date(GP.sdata.my_user.join_date)) / 1000 / 60;
            var open_threads = GP.reqres.request('MessagePane.Thread:get_open_threads');
            var show_popups = GP.reqres.request('Page:can_show_popups');
            var ft_cookie = $.cookie('free_threads');
            var date = new Date();

            // set ft_cookie obj to default if we can't grab it
            if (!ft_cookie) {
                ft_cookie = { threads: [], date: date.yyyymmdd() };
            }

            if (!first_run && show_popups && (ft_cookie.threads.length < 3 || ft_cookie.date != date.yyyymmdd()) &&
                minutes_since_join > 2 && data.unread_thread_ids.length && open_threads.length < 2) {
                var i = 0;
                var max_loops = 10;
                do {
                    i++;
                    var rand_thread_id = data.unread_thread_ids[Math.floor(Math.random()*data.unread_thread_ids.length)];
                    // do not try to open a thread that is already open
                    if (open_threads.indexOf(rand_thread_id) != -1) {
                        continue;
                    }
                    var thread_model = GP.sdata.MessagingThreads.get(rand_thread_id);
                    if (thread_model && !thread_model.get('gold_initiated') &&
                        // make sure the last message sent wasn't sent by me
                        thread_model.get('sender_duid') != GP.sdata.my_user.duid &&
                        thread_model.get('other_duid') != 69 && ft_cookie.threads.indexOf(rand_thread_id) == -1) {
                        var models = {
                            user: GP.sdata.MessagingUsers.get(thread_model.get('other_duid')),
                            thread: thread_model,
                        };
                        vent.trigger('MessagePane.Thread:create_thread', models);
                        ft_cookie.threads.push(rand_thread_id);
                        _util.set_cookie('free_threads', { threads: ft_cookie.threads, date: date.yyyymmdd() }, 1);
                        break;
                    }
                } while (i < max_loops);
            }
            // setup next time this function will run
            var min_time = 15000;
            var max_time = 45000;
            var next_auto_show = Math.floor(Math.random() * (max_time - min_time + 1) + min_time);
            setTimeout(events.auto_show_threads, next_auto_show);
        },
        request_pic_message: function() {
            var sec_since_join  = Math.abs(new Date() - new Date(GP.sdata.my_user.join_date)) / 1000;
            var show_popups = GP.reqres.request('Page:can_show_popups');

            var min_time = window._fg_min_time || 65000;
            var max_time = window._fg_max_time || 105000;

            var next_check = Math.floor(Math.random() * (max_time - min_time + 1) + min_time);
            if (show_popups && sec_since_join > 30) {
                $.get('/members/user/free_growl/', { 'rpm': 1 }, function(res) {
                    if (!res.rpm || !res.rpm.limit_reached) {
                        setTimeout(events.request_pic_message, next_check);
                    }
                });
            } else {
                setTimeout(events.request_pic_message, next_check);
            }
        },
        // Update auth user's messages to READ.
        set_messages_read: function(thread_id) {
            thread_model = GP.sdata.MessagingThreads.get(thread_id);

            if (thread_model.get('messages').has_read_status) {
                thread_model.get('messages').each(function(_model) {
                    if (_model.get('direction') == 'sender') {
                        _model.set('other_unread', 0);
                    }
                });
            }
        },
        check_verified: function() {
            if ($(this).is(':checked')) {

                if (
                    GP.sdata.my_user.verified_pic === 'N' 
                    && GP.sdata.my_user.verified_pic_pending === 'N'
                ) {
                    $(this).prop('checked', false);
                    events.show_verified_modal();
                }
            }
        },
        show_verified_modal: function() {
            GP.vent.trigger('Modal:open', {
                url: '/members/user/verify/?self_view=1',
            });
        },
        check_ages_checkbox: function() {
            if (!$(this).is(':checked')) {
                gui.$msg_age_start.val(18);
                gui.$msg_age_end.val(100);
            }
        }
    };

    this.addInitializer(function() {
        self.el  = '#message-pane';
        self.$el = $(self.el);

        data.init();
        gui.init();
        events.init();
    });
});

